import { useState, useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { paymentService } from "../services/paymentService";
import { useAuthContext } from "../components/AuthContext";

interface UsePayPayPaymentReturn {
  isLoadingPayPay: boolean;
  isPayPayCompleted: boolean;
  setIsPayPayCompleted: (value: boolean) => void;
}

export function usePayPayPayment(
  refreshContents: () => Promise<void>,
): UsePayPayPaymentReturn {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [isLoadingPayPay, setIsLoadingPayPay] = useState<boolean>(false);
  const [isPayPayCompleted, setIsPayPayCompleted] = useState<boolean>(false);
  const processedPaymentIds = useRef<Set<string>>(new Set());

  useEffect(() => {
    const merchantPaymentId = searchParams.get("merchantPaymentId");
    const chapter = searchParams.get("chapter");
    const contentId = searchParams.get("id");

    if (!merchantPaymentId || !chapter || !contentId || !user) return;

    // 既に処理済みの決済IDかチェック
    if (processedPaymentIds.current.has(merchantPaymentId)) return;

    const handlePayPayPayment = async () => {
      // 処理開始時に決済IDを記録
      processedPaymentIds.current.add(merchantPaymentId);
      setIsLoadingPayPay(true);

      try {
        const success = await paymentService.processPayPayPayment(
          user.uid,
          contentId,
          chapter,
          merchantPaymentId,
        );

        if (!success) {
          alert(
            "決済処理中にエラーが発生したため、返金いたしました。\nしばらくしてから再度お試しください。",
          );
          return;
        }

        setIsPayPayCompleted(true);
        await refreshContents();
        navigate("/my-contents");
      } catch (error) {
        console.error("PayPay payment error:", error);
        if (error instanceof Error) {
          alert(`エラーが発生しました。\n${error.message}`);
        }
      } finally {
        setIsLoadingPayPay(false);
      }
    };

    handlePayPayPayment();
  }, [searchParams, user, navigate, refreshContents]);

  return {
    isLoadingPayPay,
    isPayPayCompleted,
    setIsPayPayCompleted,
  };
}
